"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _pipe = _interopRequireDefault(require("lodash/fp/pipe"));

var _sortBy = _interopRequireDefault(require("lodash/fp/sortBy"));

var compileGroupBySuperGroup = function compileGroupBySuperGroup() {
  return (
    /*#__PURE__*/

    /* options */
    function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(rules) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _pipe.default)(function (rls) {
                  return Object.entries(rls.reduce(function (sg, rule) {
                    var rsp = typeof rule.superGroup === 'number' ? rule.superGroup : 999;
                    sg[rsp] = [].concat((0, _toConsumableArray2.default)(sg[rsp] || []), [rule]);
                    return sg;
                  }, {})).reduce(function (res, _ref2) {
                    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                        key = _ref3[0],
                        items = _ref3[1];

                    return [].concat((0, _toConsumableArray2.default)(res), [[Number(key), items]]);
                  }, []);
                }, (0, _sortBy.default)([function (tuple) {
                  return tuple[0];
                }]))(rules));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var _default = compileGroupBySuperGroup;
exports.default = _default;